var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRing2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 312,
    viewBox: "0 0 312 312",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M309.949 175.448C306.206 205.073 293.996 232.989 274.782 255.847C255.568 278.704 230.167 295.533 201.627 304.313C173.087 313.093 142.619 313.452 113.88 305.347C85.1407 297.241 59.3504 281.016 39.6035 258.617C19.8565 236.219 6.99152 208.598 2.55213 179.07C-1.88726 149.541 2.28748 119.359 14.5755 92.1443C26.8634 64.9295 46.7427 41.8381 71.8282 25.6406C96.9137 9.44317 126.14 0.827608 156 0.827637L156 31.8621C132.112 31.8621 108.731 38.7545 88.6626 51.7125C68.5942 64.6705 52.6907 83.1436 42.8604 104.915C33.03 126.687 29.6902 150.833 33.2417 174.456C36.7932 198.079 47.0852 220.175 62.8828 238.094C78.6804 256.013 99.3126 268.993 122.304 275.477C145.295 281.961 169.669 281.674 192.502 274.65C215.334 267.626 235.654 254.163 251.026 235.877C266.397 217.591 276.165 195.259 279.159 171.559L309.949 175.448Z",
    fill: "#0038FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M260.833 41.595C279.495 58.6955 293.69 80.1018 302.181 103.947C310.672 127.793 313.201 153.353 309.547 178.4L278.838 173.92C281.761 153.883 279.738 133.434 272.945 114.358C266.152 95.2815 254.796 78.1564 239.866 64.476L260.833 41.595Z",
    fill: "#F3A52F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M156 0.827637C175.558 0.827637 194.939 4.5248 213.123 11.7244L201.698 40.5795C187.151 34.8198 171.646 31.8621 156 31.8621L156 0.827637Z",
    fill: "#0038FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M156 0.827637C175.558 0.827637 194.939 4.5248 213.123 11.7244L201.698 40.5795C187.151 34.8198 171.646 31.8621 156 31.8621L156 0.827637Z",
    fill: "#FF4C19"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M212.871 11.6249C231.068 18.7927 247.745 29.3359 262.025 42.699L240.82 65.3592C229.396 54.6687 216.054 46.2342 201.497 40.4999L212.871 11.6249Z",
    fill: "#0038FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M212.871 11.6249C231.068 18.7927 247.745 29.3359 262.025 42.699L240.82 65.3592C229.396 54.6687 216.054 46.2342 201.497 40.4999L212.871 11.6249Z",
    fill: "#FF4C19",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing2);
export default __webpack_public_path__ + "static/media/ring-2.ed1d9358054ed05faf17280d7c07b3cb.svg";
export { ForwardRef as ReactComponent };